import { render, staticRenderFns } from "./Jkrk.vue?vue&type=template&id=622a1286&scoped=true&"
import script from "./Jkrk.vue?vue&type=script&lang=js&"
export * from "./Jkrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a1286",
  null
  
)

export default component.exports